import Vue from 'vue'
import Vuex from 'vuex'
// import moment from 'moment'

Vue.use(Vuex)

const config = {
  heartbeatInterval: 120
}

/**
 * @see {@link https://stackoverflow.com/questions/10730362/get-cookie-by-name#answer-40786371}
 * @param name
 * @returns {string}
 */
const getCookie = name => {
  let a = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`)
  return a ? a[1] : ''
}

let root = '/api/'
if (process.env.NODE_ENV === 'production') {
  root = 'http://' + window.location.hostname + '/'
}

function arrayUnique (array) {
  var a = array.concat()
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1)
    }
  }
  return a
}

const state = {
  config: config,
  showLoader: false,
  api: root,
  user: false,
  backendConfig: {},
  lang: {},
  privileges: [],
  networks: [],
  allNetworks: [],
  devices: [],
  devicePage: 1,
  devicePerPage: 8,
  deviceViewType: 'thumbs',
  escLevel: 0,
  counter: 1,
  locale: 'en',
  isUserAuthenticated: !!(getCookie('userid')),
  filterState: false,
  filterInActive: false,
  filterStandby: false,
  filterName: '',
  filterNetwork: null,
  enableMinVersion: '1.19.0',
  loginProviders: [],
  openDetailId: undefined
}
const getters = {
  loginProvidersFiltered: state => {
    return state.loginProviders.filter(el => el.id !== 'local')
  },
  enableMinVersion: state => {
    return state.enableMinVersion
  },
  user: state => {
    return state.user
  },
  backendConfig: state => {
    return state.backendConfig
  },
  lang: state => {
    return state.lang
  },
  isUserAuthenticated: state => {
    return state.isUserAuthenticated
  },
  devices: (state, getters) => {
    if (getters.filterNetwork === 0) {
      return state.devices
    }
    return state.devices
      .filter(device => {
        return device.network === getters.filterNetwork
      })
  },
  standby: (state, getters) => {
    const errored = state.devices
      .filter(device => {
        return device.kiosk_status === 'standby'
      })
    if (getters.filterNetwork === 0) {
      return errored
    }
    return errored
      .filter(device => {
        return device.network === getters.filterNetwork
      })
  },
  errored: (state, getters) => {
    const errored = state.devices
      .filter(device => {
        return device.kiosk_status === 'malfunction'
      })
    if (getters.filterNetwork === 0) {
      return errored
    }
    return errored
      .filter(device => {
        return device.network === getters.filterNetwork
      })
  },
  inActive: (state, getters) => {
    const inActive = state.devices
      .filter(device => {
        const result = device.hbtime && new Date().getTime() < new Date(device.hbtime + state.config.heartbeatInterval * 2 * 1000).getTime()
        return !result
      })
    if (getters.filterNetwork === 0) {
      return inActive
    }
    return inActive
      .filter(device => {
        return device.network === getters.filterNetwork
      })
  },
  networks: state => {
    return state.networks.sort((a, b) => a.name.localeCompare(b.name))
  },
  allNetworks: state => {
    return state.allNetworks.sort((a, b) => a.name.localeCompare(b.name))
  },
  filterName: state => {
    return state.filterName
  },
  filterNetwork: state => {
    return state.filterNetwork
  },
  filteredDevices: (state, getters) => {
    const foundName = getters.devices
      .filter(device => device.name.toLowerCase().search(getters.filterName.toLowerCase()) >= 0)
    const foundDesc = getters.devices
      .filter(device => device.description.toLowerCase().search(getters.filterName.toLowerCase()) >= 0)
    const foundUuid = getters.devices
      .filter(device => device.uuid.toLowerCase().search(getters.filterName.toLowerCase()) >= 0)
    // filter serial numbers
    const foundSerial = getters.devices
      .filter(device => {
        if (!device.serial) {
          return false
        }
        return device.serial.toLowerCase().search(getters.filterName.toLowerCase()) >= 0
      })
    const foundIp = getters.devices
      .filter(device => {
        if (!device.localIP) {
          return false
        }
        return device.localIP.search(getters.filterName.toLowerCase()) >= 0
      })
    const foundText = arrayUnique(foundName.concat(foundDesc).concat(foundUuid).concat(foundIp).concat(foundSerial))
    const filteredDevices = foundText
      .filter(device => {
        if (!state.filterStandby) return true
        return device.kiosk_status === 'standby'
      })
      .filter(device => {
        if (!state.filterState) return true
        return device.kiosk_status === 'malfunction'
      })
      .filter(device => {
        const result = device.hbtime && new Date().getTime() < device.hbtime + state.config.heartbeatInterval * 2 * 1000
        if (!state.filterInActive) return true
        return !result
      })
    return filteredDevices
  },
  hasRole: state => rolesArr => {
    let found = false
    rolesArr.forEach(rolename => {
      const res = state.user.roles.find(role => role.name === rolename)
      if (res) found = true
    })
    return found
  },
  openDetailId: state => state.openDetailId
}
const actions = {
  getUser (context, user) {
    context.commit('SET_USER', user)
    context.commit('increment')
  },
  addDeviceFilter (context, payload) {
    switch (payload.type) {
      case 'name':
        context.commit('SET_DEVICES_FILTER_NAME', payload.needle)
        break
    }
  }
}
const mutations = {
  /**
   * @param state
   * @param level number
   */
  SET_ESC_LEVEL (state, level) {
    state.escLevel = level
  },

  /**
   * @param state
   * @param type enum thumbs | rows
   */
  CHANGE_DEVICE_VIEW_TYPE (state) {
    state.deviceViewType = (state.deviceViewType === 'thumbs') ? 'list' : 'thumbs'
  },

  /**
   * @param state
   * @param bool
   */
  SET_LOADER (state, bool) {
    state.showLoader = bool
  },

  /**
   * @param state
   * @param user
   */
  SET_USER (state, user) {
    state.user = user
  },

  /**
   *
   * @param {*} state
   * @param {*} config
   */
  SET_BACKEND_CONFIG (state, config) {
    state.backendConfig = config
  },

  /**
   * @param state
   * @param lang
   */
  SET_LANG (state, lang) {
    state.lang = lang
  },

  /**
   * @param state
   * @param loginProviders
   */
  SET_LOGIN_PROVIDER (state, loginProviders) {
    state.loginProviders = loginProviders
  },

  /**
   * @param state
   * @param newConfig
   */
  SET_CONFIG (state, newConfig) {
    state.config = { ...state.config, ...newConfig }
  },

  /**
   * @param state
   * @param privileges
   */
  SET_PRIVILEGES (state, privileges) {
    state.privileges = privileges
  },

  /**
   * @param state
   * @param networks
   */
  SET_NETWORKS (state, networks) {
    state.networks = networks
  },

  /**
   * @param state
   * @param networks
   */
  SET_ALL_NETWORKS (state, allNetworks) {
    state.allNetworks = allNetworks
  },

  /**
   * @param state
   * @param isUserAuthenticated
   */
  SET_IS_USER_AUTHENTICATED (state, isUserAuthenticated) {
    state.isUserAuthenticated = isUserAuthenticated
  },

  /**
   * @param state
   * @param locale
   * @constructor
   */
  SET_LOCALE (state, locale) {
    state.locale = locale
  },

  /**
   * @param state
   * @param devices
   */
  SET_DEVICES (state, devices) {
    state.devices = devices
    store.commit('SET_DEVICES_PAGE', 1)
  },

  /**
   * @param state
   * @param devices
   */
  SET_DEVICES_NOT_PAGE (state, devices) {
    state.devices = devices
  },

  /**
   * @param state
   * @param device
   */
  REMOVE_DEVICE (state, deviceId) {
    let deviceFound = state.devices.filter(device => device.id === deviceId)[0]
    let deviceIndex = state.devices.indexOf(deviceFound)
    if (deviceIndex > -1) {
      state.devices.splice(deviceIndex, 1)
    }
  },

  /**
   * @param state
   * @param msg
   */
  SET_DEVICE (state, msg) {
    let deviceFound = state.devices.filter(device => device.id === msg.id)[0]
    let deviceIndex = state.devices.indexOf(deviceFound)
    msg.screenshot = deviceFound.screenshot
    Vue.set(state.devices, deviceIndex, msg)
  },

  /**
   * @param state
   * @param page
   */
  SET_DEVICES_PAGE (state, page) {
    if (page === 1) {
      state.devicePage = page
    }
    if ((page > 0) && (store.getters.filteredDevices.length / state.devicePerPage > page - 1)) {
      state.devicePage = page
    }
  },

  /**
   * @param state
   * @param page
   */
  SET_DEVICES_PERPAGE (state, perPage) {
    state.devicePerPage = perPage
  },

  /**
   * @param state
   * @param status
   */
  SET_DEVICES_FILTER_NAME (state, status) {
    state.devicePage = 1
    state.filterName = status
  },

  /**
   * @param state
   * @param network
   */
  SET_DEVICES_FILTER_NETWORK (state, network) {
    state.filterNetwork = parseInt(network, 10)
  },

  /**
   * @param state
   * @param status
   */
  SET_DEVICES_FILTER_STATE (state, status) {
    state.devicePage = 1
    state.filterState = status
  },

  /**
   * @param state
   * @param status
   */
  SET_DEVICES_FILTER_STANDBY (state, status) {
    state.devicePage = 1
    state.filterStandby = status
  },

  /**
   * @param state
   * @param status
   */
  SET_DEVICES_FILTER_ACTIVE (state, status) {
    state.devicePage = 1
    state.filterInActive = status
  },

  /**
   * @param state
   * @param openDetailId
   */
  SET_OPENDETAILID (state, openDetailId) {
    state.openDetailId = openDetailId
  },

  /**
   * @param state
   */
  CANCEL_DEVICES_FILTER (state) {
    state.devicePage = 1
    state.filterName = ''
  }
}

export const store = new Vuex.Store({
  // strict: true,
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js